<template>
  <v-dialog v-model="visible" max-width="638" persistent>
    <v-card v-if="visible" class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text v-html="$t(`${namespace}.text`).replace('[COMPANY]', company.companyName)" class="px-4 pt-0 pb-5" />

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer/>

        <a
          v-if="!isLoading"
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close(null)"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="accent"
          depressed
          round
          @click.native="handleSubmit"
        >
          {{ $t(`${namespace}.confirm`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ChangeCompanyStatusDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    company: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyPage.anonymousCompanies.approveAnonymizationDialog',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    close (reload = null) {
      this.$emit('close', reload)
    },

    async handleSubmit () {
      this.isLoading = true

      try {
        const isValid = await this.$validator.validateAll()

        if (isValid) {
          await this.$apiService.companyDataPurge.confirm(this.company.companyId)
          this.close(true)
          this.showAlert({
            type: 'success',
            message: this.$t(`${this.namespace}.success`)
          })
        }
      } catch (err) {
        let type = 'error'
        let message = this.$t(`${this.namespace}.error`)

        if (err && err.response && err.response.status === 403) {
          type = 'info'
          message = this.$t(`${this.namespace}.accessDenied`)
        }

        this.showAlert({ type, message })
      }

      this.isLoading = false
    }
  }
}
</script>
